import produce from 'immer';

const INITIAL_STATE = {
  data: null,
};

export default function trabalhos(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@trabalhos/REQUEST_SUCCESS': {
        draft.data = action.payload.trabalhos;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.data = null;
        break;
      }
      default:
    }
  });
}
